import { Container, Inform } from "./styles";

export default function Back3() {
    return(
        <Container>
            <h2>CERTIFICAÇÕES</h2>
            <div>
                <Inform>
                    <h3>Inglês Avançado</h3>
                    <h4>For You Idiomas | 2020</h4>
                </Inform>
                <Inform>
                    <h3>Design Gráfico</h3>
                    <h4>Udemy | 2021</h4>
                </Inform>
                <Inform>
                    <h3>Desenvolvimento C#</h3>
                    <h4>ProWay | 2021</h4>
                </Inform>
                <Inform>
                    <h3>ReactJS Front-end</h3>
                    <h4>Rocketseat | 2022</h4>
                </Inform>
                <Inform>
                    <h3>Computação em Nuvem</h3>
                    <h4>Estacio/AWS | 2023</h4>
                </Inform>
                <Inform>
                    <h3>Java</h3>
                    <h4>Rocketseat | 2023</h4>
                </Inform>
            </div>
        </Container>
    )
}